import type { BroadcastContent } from '../../api/types';
import { POLLY_LANGUAGE_OPTIONS } from '../../data/pollyVoices';
import { resolvePreviewVoiceId, type VoiceSelections } from '../../utils/voiceSettings';

/**
 * 試聴キュー (言語 × コンテンツ) を組み立てる。
 *
 * 話者は言語ごとに決まる (Issue #639): 日本語は `parentVoiceId` (放送地点の `voice_id`)、
 * それ以外は `voiceSelections[言語キー]`。未選択 / その言語で使えない話者は `undefined`
 * (= サーバがその言語の既定話者を使う)。
 *
 * `train_info` (運行情報) も対象に含める。配信が無い (400) / 取得できない (502) 場合は、
 * 他カテゴリの検証エラーと同じく、通し試聴では「スキップされた」警告として扱われる。
 */
export function buildPreviewQueue(
  contents: BroadcastContent[],
  parentVoiceId?: string,
  voiceSelections?: VoiceSelections,
) {
  return POLLY_LANGUAGE_OPTIONS.flatMap((language) =>
    contents.flatMap((content, index) =>
      (content.languages ?? ['ja']).includes(language.key)
        ? [
            {
              content,
              language: language.key,
              voiceId: resolvePreviewVoiceId(language.key, parentVoiceId, voiceSelections),
              label: `#${index + 1} ${content.category} (${language.label})`,
            },
          ]
        : [],
    ),
  );
}
